"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIEW_COMMENT_PERMISSION_KEY = "b1349856-5d6d-11eb-ae93-0242ac130002";
exports.ADD_COMMENT_PERMISSION_KEY = "2193e690-5ee7-11eb-ae93-0242ac130002";
exports.EDIT_DELETE_COMMENT_PERMISSION_KEY = "33703026-5ee7-11eb-ae93-0242ac130002";
//# sourceMappingURL=constants.js.map